import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Fade from "@mui/material/Fade";
import { css } from "@emotion/react";

export const LoadingSpinner = ({ className }: { className?: string }) => {
  return (
    <Box
      className={className}
      css={css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100vh;
        height: 100dvh;
      `}
    >
      <Fade
        in={true}
        style={{
          transitionDelay: "800ms",
        }}
        unmountOnExit
      >
        <CircularProgress color="primary" />
      </Fade>
    </Box>
  );
};
